import { Address } from '@mfe/shared/schema-types';

import { AddressR0 } from '@viasat/res-apps-lib/build/types/vail';

export function formatAddressOnTwoLines(
  address: AddressR0 | Address | undefined | null
) {
  if (!address) {
    return [];
  }
  const { addressLines, region, postalCode, municipality } = address;
  const line1 =
    addressLines.length > 1 && addressLines[1]
      ? addressLines.join(', ')
      : addressLines[0];
  const line2 = `${municipality}, ${region} ${postalCode}`;
  return [line1, line2];
}
